import React, { useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Container } from '@material-ui/core'
import Loader from '../../elements/Loader';
import { useHistory } from 'react-router';
import { useQuery } from 'react-query';
import { getAdsStatistic } from '../../api/source';

const Search = (props) => {
    const history = useHistory()
    const { currentUser } = props;

    useEffect(() => {
        if (currentUser && currentUser?.optional?.role !== 'admin') history.push('/');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    const { data, isLoading } = useQuery('tracking', getAdsStatistic)

    const rows = data?.data;

    return (
        <div>
            {isLoading && <Loader />}
            <div className="text-center">
                <Container maxWidth='lg' style={{ padding: '24px' }}>
                    <h1>Tracking Ads</h1>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Source</TableCell>
                                <TableCell align="right">Clicks</TableCell>
                                <TableCell align="right">Registrations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows?.map((row) => (
                                <TableRow
                                    key={row._id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="right">{row.clicks?.length}</TableCell>
                                    <TableCell align="right">{row.registrations?.length}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Container>
            </div>
        </div>
    )
}

export default Search